<div class="search-component">
  <div class="input-group">
    <input type="text" placeholder="Insira o CPF/CNPJ" [(ngModel)]="inputCPFCNPJ" (keyup)="handleMaskInput()">
    <button class="search-btn">
      <span class="search-icon">🔍</span>
    </button>
  </div>
  <button class="main-btn" (click)="handleSubmit()">BUSCAR</button>
</div>


<ng-container *ngIf="dataQueuesUser">
  <div class="table-container" *ngIf="dataQueuesUser.canais">
    <div class="header">
      <button class="btn-add" (click)="handleOpenModalNewQueue()">NOVA FILA</button>
      <h4 class="title-client">Cliente: {{dataQueuesUser.cliente.nome}}</h4>
      <label class="label-title"><mat-icon title="Canais cadastrados/Canais disponiveis">info</mat-icon>{{dataQueuesUser.canais.length}}/{{dataQueuesUser.configuracoes.quantidadecanais}}</label>
    </div>
    <table class="custom-table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>ID Fila</th>
          <th>API Key</th>
          <th>Tipo</th>
          <th>Disparos</th>
          <th>Excluir</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let canal of dataQueuesUser.canais">
          <td>{{canal.nomefila}}</td>
          <td>{{canal.queueId}}</td>
          <td>{{canal.apiKey}}</td>
          <td>{{canal.type}}</td>
          <td>{{canal.fire}}</td>
          <td><button class="btn-delete"
              (click)="handleDeleteChannel(canal.idcanal)"><mat-icon>delete</mat-icon></button></td>
        </tr>
      </tbody>
    </table>
    <!-- <div class="footer">
    <span>Registros por página:</span>
    <select>
      <option>5</option>
      <option>10</option>
      <option>15</option>
    </select>
    <span>1-3 de 3</span>
  </div> -->
  </div>
</ng-container>

<ng-container *ngIf="isModalDelete">
  <div id="modal-delete" class="modal-delete">
    <div class="modal-delete-content">
      <h2>Confirmar Exclusão</h2>
      <p>Tem certeza de que deseja excluir este canal? Esta ação não pode ser desfeita.</p>
      <div class="modal-delete-actions">
        <button class="modal-delete-btn-cancel" (click)="handleCancelDeleteChannel()">Cancelar</button>
        <button class="modal-delete-btn-confirm" (click)="confirmHandleDeleteChannel()">Excluir</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isModalNewQueue">
  <div id="modal-new-queue" class="modal-new-queue">
    <div class="modal-new-queue-content">
      <button class="modal-new-queue-close" (click)="handleCloseModalNewQueue()"><mat-icon>close</mat-icon></button>
      <h2>Nova Fila</h2>
      <form class="modal-new-queue-form" [formGroup]="formQueue">
        <div class="modal-new-queue-row">
          <input type="text" placeholder="Nome da fila" class="modal-new-queue-input" formControlName="nomefila" />
          <input type="text" placeholder="ID da fila" class="modal-new-queue-input" formControlName="queueId" />
        </div>
        <div class="modal-new-queue-row">
          <input type="text" placeholder="ApiKey" class="modal-new-queue-input" formControlName="apiKey" />
          <label class="modal-new-queue-label">
            Selecione o tipo
            <select class="modal-new-queue-select" formControlName="type" (change)="handleChangeTypeQueue()">
              <option value="NORMAL">Normal</option>
              <option value="APIOFICIAL">API Oficial</option>
            </select>
          </label>
        </div>
        <div class="modal-new-queue-row">
          
        </div>
        <div class="modal-new-queue-row">
          <input type="range" min="3" [max]="rangeMaxFire" value="3" class="modal-new-queue-slider" formControlName="fire"/>
          <span class="modal-new-queue-slider-value">{{formQueue.get('fire')?.value}}</span>
        </div>
        <div class="modal-new-queue-actions">
          <button type="button" class="modal-new-queue-btn-save" (click)="handleSubmitForm()">Salvar</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>